import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { CircularProgress } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { SignalCellularConnectedNoInternet0Bar, SignalCellular0Bar, SignalCellular1Bar, SignalCellular2Bar, SignalCellular3Bar, SignalCellular4Bar } from '@mui/icons-material';
import useErrorManager from "../../hooks/useErrorManager";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import GenericTable from '../Layout/Table/GenericTable';
import TextFilter from "../Layout/Table/TextFilter"

import { useNotification } from '../../contexts/NotificationContext';

function NetworkScanTable({ gatewayId }) {
    const [networks, setNetworks] = useState([]);

    const [loading, setLoading] = useState(true);

    const { setError, clearError } = useErrorManager();
    const { showNotification } = useNotification();

    const navigate = useNavigate();
    const axiosInstance = useAxiosPrivate();

    // const columns = [
    //     { id: 'networkNumber', label: 'Network ID', filtered: true  },
    //     { id: 'nodeId', label: 'Node position' },
    //     { id: 'signalQuality', label: 'Signal Rating', render: (item) => renderSignalQuality(item.signalQuality)  },
    //     { id: 'linkMargin', label: 'Reception Level' }
    // ];

    useEffect(() => {
        const fetchNetworksScanByGateway = async () => {
            try {
                setLoading(true);
                const response = await axiosInstance.get(`/net/scan/${gatewayId}`, {
                    withCredentials: true,
                });
                setNetworks(response.data);
                clearError('fetch');
            } catch (error) {
                setError('fetch', error.message);
                showNotification('Failed to fetch network scan for the gateway', 'error');
            } finally {
                setLoading(false);
            }

        };

        if (gatewayId) {
            fetchNetworksScanByGateway();
        }
    }, [gatewayId]);

    // const renderSignalQuality = (quality) => {
    //     const qualityMap = {
    //         "out of range": { level: 1, label: "Out of Range", icon: <SignalCellular0Bar color="error" /> },
    //         "low": { level: 2, label: "Low", icon: <SignalCellular1Bar style={{color:"orange"}} /> },
    //         "moderate": { level: 3, label: "Moderate", icon: <SignalCellular1Bar style={{color:"green"}} /> },
    //         "good": { level: 4, label: "Good", icon: <SignalCellular2Bar style={{color:"green"}} />},
    //         "very good": { level: 5, label: "Very Good", icon: <SignalCellular3Bar style={{color:"green"}} />},
    //         "superior": { level: 6, label: "Superior", icon: <SignalCellular4Bar style={{color:"green"}} /> },
    //     };
        
    //     const qualityData = qualityMap[quality.toLowerCase()] || { level: 0, label: "Unknown", icon: <SignalCellularConnectedNoInternet0Bar color="gray" /> };

    //     return (
    //             qualityData.icon
    //     );
    // };
    const renderSignalQuality = (params) => {
        const quality = params.value?.toLowerCase();
        const qualityMap = {
            "out of range": <SignalCellular0Bar color="error" />,
            "low": <SignalCellular1Bar style={{ color: "orange" }} />,
            "moderate": <SignalCellular1Bar style={{ color: "green" }} />,
            "good": <SignalCellular2Bar style={{ color: "green" }} />,
            "excellent": <SignalCellular3Bar style={{ color: "green" }} />,
            "superior": <SignalCellular4Bar style={{ color: "green" }} />,
        };

        return qualityMap[quality] || <SignalCellularConnectedNoInternet0Bar color="gray" />;
    };

    const columns = [
        { field: 'networkNumber', headerName: 'Network ID', flex: 1 },
        { field: 'nodeId', headerName: 'Node Position', flex: 1 },
        { field: 'signalQuality', headerName: 'Signal Rating', flex: 1, renderCell: renderSignalQuality },
        { field: 'linkMargin', headerName: 'Reception Level', flex: 1 },
    ];

    return (
         loading ? (
                <CircularProgress />
            ) : (
                    <DataGrid
                        rows={networks}
                        columns={columns}
                        getRowId={(row) => `${row.networkNumber}_${row.nodeId}`}
                        initialState={{
                            sorting: {
                                sortModel: [{ field: 'linkMargin', sort: 'desc' }],
                            },
                            pagination: {
                              paginationModel: { pageSize: 5, page: 0 },
                            },
                        }}
                        pageSizeOptions={[5, 10, 20]}
                        disableSelectionOnClick
                    />
            )
    );
}

export default NetworkScanTable;
